<template>
  <zt-modal
    :active="activeModal"
    :show-button-close="false"
    :title="$t('message.DownloadAllDocuments.downloadModal.titleChangeCompany')"
    max-width="600px"
  >
    <div class="flex flex-col items-center justify-center p-8 lg:p-20">
      <div class="text-center text-zt-lg mb-4">
        <p>
          {{$t('message.DownloadAllDocuments.downloadModal.messageRedirect')}}
        </p>
      </div>

      <div v-if="companyInfo" class="company-card w-full rounded flex items-center px-3">
        <div class="w-2/6 md:w-1/4">
          <div class="w-24 flex justify-center items-center border rounded border-custom-gray px-1">
            <div
              class="company-logo flex items-center justify-center"
            >
              <img :src="companyInfo.empresa.companyLogo" alt="" />
            </div>
          </div>
        </div>
        <div class="w-3/6 md:w-2/4 py-4 flex flex-wrap">
          <span class="w-full font-bold text-zt-dark-500">{{ companyInfo.empresa.nombre }}</span>
          <span class="w-full company-info">{{ companyInfo.pais }}</span>
        </div>
        <div class="w-1/6 md:w-1/4 my-auto flex justify-end items-end">
          <div v-if="loader" class="company-change-loader"></div>
          <div v-else
            class="changed-icon flex items-center justify-center flex-none">
            <zt-icon name="check" />
          </div>
        </div>
      </div>
    </div>
  </zt-modal>
</template>
<script>

export default {
  name: 'SwitchCompanyFactory',
  props: {
    activeModal: {
      type: Boolean,
      default: false
    },
    companyInfo: {
      type: Object,
      default: () => {}
    },
    loader: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss">
.company-change-loader {
  border: 2px solid;
  border-color: #898DFF;
  border-top: 2px solid transparent;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  animation: spin 2s linear infinite;
}

.border-custom-gray {
  border-color: #CACACA;
}

.company-card {
  border: solid 2px #898DFF;
  height: 88px;

  .company-logo {
    width: 82px;
    height: 59px;
  }

  .changed-icon {
    border-radius: 50%;
    background: #54CAA6;
    width: 22px;
    height: 22px;
    font-size: 10px;
    color: #FFF;
  }
}
</style>